import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white customer-satisfaction-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-md-25 d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "card-title fw-bold mb-0" }
const _hoisted_5 = {
  key: 0,
  id: "customerSatisfactionChart",
  class: "chart"
}
const _hoisted_6 = { class: "list ps-0 mb-0 list-unstyled text-center" }
const _hoisted_7 = { class: "d-flex align-items-center mb-10" }
const _hoisted_8 = { class: "fs-12 fw-medium text-black-emphasis text-uppercase lh-1 ms-8" }
const _hoisted_9 = { class: "d-flex align-items-end" }
const _hoisted_10 = { class: "mb-0 text-black-emphasis lh-1 fw-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.graphTitle), 1)
      ]),
      (_ctx.preparedData.inputValues != undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_apexchart, {
              type: "pie",
              height: "240",
              options: _ctx.preparedData.chart,
              series: _ctx.preparedData.inputValues
            }, null, 8, ["options", "series"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparedData.inputValues, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.productName,
            class: "d-inline-block text-start"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: "d-block w-10 h-10 rounded-circle",
                style: _normalizeStyle({ 'background-color': _ctx.preparedData.chart.colors[index]})
              }, null, 4),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.preparedData.chart.labels[index]), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", _hoisted_10, _toDisplayString(item), 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fw-bold text-danger d-inline-block position-relative top-1 ms-5" }, null, -1))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}